import React from 'react';
import styled from '@emotion/styled';
import { colors } from '../theme/colors';

const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: ${props => props.isActive ? colors.badge.dark.active : '#3a3a3a'};
  color: ${props => props.isActive ? 'white' : '#f0f0f0'};
  font-size: 12px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  white-space: nowrap;
  opacity: ${props => props.disabled ? 0.5 : 1};
  
  &:hover:not(:disabled) {
    background: ${props => props.isActive ? colors.badge.dark.hover : '#4a4a4a'};
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const CountBadge = styled.span`
  background: ${props => props.isActive ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)'};
  color: ${props => props.isActive ? 'white' : '#f0f0f0'};
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  min-width: 16px;
  text-align: center;
`;

const FilterButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const FilterButtonComponent = ({ 
  isActive = false, 
  disabled = false, 
  onClick, 
  children, 
  count,
  ...props 
}) => {
  return (
    <FilterButton 
      isActive={isActive} 
      disabled={disabled} 
      onClick={onClick}
      {...props}
    >
      {children}
      {count !== undefined && (
        <CountBadge isActive={isActive}>
          {count}
        </CountBadge>
      )}
    </FilterButton>
  );
};

export default FilterButtonComponent;
export { FilterButtonGroup };

